import PropTypes from 'prop-types';
import React from 'react';
import { Button, Table, Modal } from 'react-bootstrap';
import { daysBetween } from '../../../core/date';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import ExpandRow from './ExampleGrid';
import ManageEditBid from './ManageEditBid';
import moment from 'moment';

function calculate(bid, nights) {
  let sum = 0;
  if (bid.bidset.suites) {
    sum += Number(bid.suite_rate || 0) * bid.bidset.suites * nights;
  }
  if (bid.bidset.kings) {
    sum += Number(bid.king_rate || 0) * bid.bidset.kings * nights;
  }
  if (bid.bidset.queens) {
    sum += Number(bid.queen_rate || 0) * bid.bidset.queens * nights;
  }
  return sum;
}

function calculateTax(subTotal, taxRate) {
  if (taxRate) {
    return Number(taxRate || 0) * subTotal;
  }
  return 0;
}

function totalCalculate(bidbidsDetails, bid){
  let sum = 0;
  let totalVal = 0;
  const additional_tax = bid.hotel.additional_tax;
  const resort_fee = bid.resort_fee;
  const tax = bid.hotel.tax_rate;
  const add = Number(additional_tax);
  const resort = Number(resort_fee);
  const taxValue = Number(tax);
  const tax_rate = taxValue? taxValue: 0;
  const addTax = add? add : 0;
  const resortFee = resort? resort : 0;
  let diff = 0;
  let add_Tax = 0;
  let rert_fee = 0;
  let taxRat = 0;
  let taxRate = 0;
  let bid_details = bidbidsDetails.filter(c => c.bid_details.room_type);
  bid_details.map(c => {
    const a = moment(c.bid_details.check_out_date);
    const b = moment(c.bid_details.check_in_date);

    add_Tax = Number(addTax) * a.diff(b, 'days')
    rert_fee = Number(resortFee) * a.diff(b, 'days')

    taxRat = tax_rate * Number(c.rate_per_night)
    taxRate = taxRat * a.diff(b, 'days')
    sum += (Number(c.rate_per_night) * a.diff(b, 'days'))+ add_Tax + rert_fee + taxRate;

  })
  totalVal = parseFloat(sum).toFixed(2);
  return totalVal;
}


const formatMoney = (value, currency) => {
  if (!value) return value;
  // const onlyNums = value.replace(/[^\d]/g, '');
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    minimumFractionDigits: 2,
    currency,
  });
  return formatter.format(value);
};



class BidDetailTable extends React.Component {
  constructor(props) {
    super(props);
    this.state ={
      roomType:null,
    }
    this.deleteTourMember = this.deleteTourMember.bind(this);
  }

  deleteTourMember(payload){
    const id = payload.id;
    const group = payload.group_id;
    const roomType = payload.roomType;
    this.props.dispatchRemoveMemberFromManageBid(group,id)
    this.setState({ roomType:id });
    this.props.onDeleteData(id);
  }

  render() {
    const { bid } = this.props;
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'percent',
      minimumFractionDigits: 3,
    });

    const currency = this.props.bid.currency;
    const taxRate = formatter.format(this.props.bid.hotel.tax_rate);
    const commissionRate = formatter.format(this.props.bid.commission_rate);
    const nights = daysBetween(bid.bidset.event.end, bid.bidset.event.start);

    const subTotal = calculate(this.props.bid, nights);
    const tax = calculateTax(subTotal, this.props.bid.hotel.tax_rate);
    const totalRate = subTotal + tax;
    // const resortfee = this.props.bid.hotel.resort_fee;
    // Displaying resort fee of bid
    const resortfee = this.props.bid.resort_fee;
    const additionalTax = this.props.bid.hotel.additional_tax;

    const showCommission = !this.props.isTourManager;
    let total = totalCalculate(this.props.bidbidsDetails, bid)

    return (
      
        <div className="col-md-12">
          {this.props.canEdit && <span><Button onClick={this.props.handleEdit}>Edit</Button>&nbsp;&nbsp;</span>}
          {/* <Button bsStyle="info" onClick={this.props.openPopUp}>Edit Bid</Button>&nbsp;&nbsp;<small style={{ color: "green"}}>Click on Edit Bid button for changing the room type & check In/Out date.</small> */}
          <p>Currency: {currency}</p>


        <ExpandRow bid={this.props.bid}
        tourData={this.props.tourData}
        editMember={this.props.editMember}
        bidbidsDetails={this.props.bidbidsDetails}
        isLoading={this.props.isLoading}
        roomType={this.state.roomType}
        ></ExpandRow>
          {showCommission?(
            <p>Commission: {commissionRate} <br/> Tax Rate: {taxRate} <br/> Additional Tax(per day): {currency}&nbsp;{additionalTax} <br/> Resort Fee(per day): {currency}&nbsp;{resortfee} <br/> Total : {currency}&nbsp;{total}</p>):(
            <p>Tax Rate: {taxRate} <br/> Additional Tax(per day): {currency}&nbsp;{additionalTax} <br/> Resort Fee(per day): {currency}&nbsp;{resortfee} <br/> Total : {currency}&nbsp;{total}</p>)}
        {this.props.showPopUp && (
          <ManageEditBid
          showPopUp={this.props.showPopUp}
          OnClose={this.props.OnClose}
          bid={this.props.bid}
          tour={this.props.tourData}
          editGroup={this.props.editGroup}
          bidbidsDetails={this.props.bidbidsDetails}
          ChangeBidDetail={this.props.ChangeBidDetail}
          changeBidDateDetail={this.props.changeBidDateDetail}
          editGroupEventOnManageBid={this.props.editGroupEventOnManageBid}
          dispatchRemoveMemberFromManageBid={this.props.dispatchRemoveMemberFromManageBid}
          requestBidDetails={this.props.requestBidDetails}
          editMember={this.props.editMember}
          deleteTourMember={this.deleteTourMember}
          changeDateRoomType={this.props.changeDateRoomType}
          addParticipantManageBid={this.props.addParticipantManageBid}
          changeData={this.props.changeData}
          updateBidData={this.props.updateBidData}
          />
          )}
        </div>
      
    );
  }
}

BidDetailTable.propTypes = {
  bid: PropTypes.object.isRequired,
  canEdit: PropTypes.bool.isRequired,
  isTourManager: PropTypes.bool.isRequired,
  handleEdit: PropTypes.func.isRequired,
  tourData: PropTypes.object,
  editMember: PropTypes.func,
  changeDateRoomType:PropTypes.func,
  dispatchRemoveMemberFromManageBid:PropTypes.func,
  addParticipantManageBid: PropTypes.func,
};

export default BidDetailTable;



// WEBPACK FOOTER //
// src/routes/tours/components/BidDetailTable.js